<template>
    <TransitionRoot
        appear
        as="template"
        :show="isOpen">
        <Dialog
            as="div"
            :style="`padding-right: ${modalPadding}`"
            :class="{
                'flex h-full w-full items-center justify-center': center,
                'overflow-x-hidden': !isDisabledPanelOverflowxDialog,
            }"
            class="fixed inset-0 z-50 overflow-y-auto"
            @close="closeModal">
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0">
                <div
                    v-show="transitionDirection === 'default'"
                    style="
                        cursor:
                            url(/assets/images/ui/icons/jpg-png/close-cursor.png),
                            pointer;
                    "
                    class="fixed inset-0 bg-black/60 backdrop-blur-[0.40625rem]" />
            </TransitionChild>
            <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0">
                <div
                    v-show="blurBackground"
                    :class="{
                        'backdrop-blur-[0.40625rem]': !disableMobileBlur,
                        'md:backdrop-blur-[0.40625rem]': disableMobileBlur,
                    }"
                    class="fixed inset-0 bg-black/60" />
            </TransitionChild>
            <TransitionChild
                as="template"
                enter="duration-[400ms] ease-out"
                leave="duration-300 ease-in"
                :enter-from="
                    transitionDirection === 'default'
                        ? 'opacity-0 scale-95'
                        : transitionDirection === 'left'
                          ? '-translate-x-full'
                          : 'translate-x-full'
                "
                :enter-to="
                    transitionDirection === 'default'
                        ? 'opacity-100 scale-100'
                        : transitionDirection === 'left'
                          ? 'translate-x-0'
                          : 'translate-x-0'
                "
                :leave-from="
                    transitionDirection === 'default'
                        ? 'opacity-100 scale-100'
                        : transitionDirection === 'left'
                          ? 'translate-x-0'
                          : 'translate-x-0'
                "
                :leave-to="
                    transitionDirection === 'default'
                        ? 'opacity-0 scale-95'
                        : transitionDirection === 'left'
                          ? '-translate-x-full'
                          : 'translate-x-full'
                ">
                <div
                    :class="{
                        'container left-0 flex h-full max-w-full': video,
                        'inline-flex h-full': center,
                        'right-0': transitionDirection === 'right',
                        'left-0': transitionDirection === 'left',
                        'fixed top-0 md:w-[100vw]': !video,
                    }"
                    class="h-full w-full">
                    <DialogPanel
                        :class="{
                            'aspect-video h-[65%] max-w-full': video,
                            'm-auto flex justify-center': video || center,
                            'overflow-x-hidden overflow-y-hidden max-md:max-h-full max-md:overflow-y-auto':
                                !video && !isDisabledPanelOverflowxDialog,
                            container: !video && !isDisabledPaddingTablet,
                            'max-md:container lg:container':
                                !video && isDisabledPaddingTablet,
                        }"
                        class="">
                        <slot />
                    </DialogPanel>
                </div>
            </TransitionChild>
        </Dialog>
    </TransitionRoot>
</template>

<script setup lang="ts">
import {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'
import { useScrollLock } from '@vueuse/core'

const props = defineProps({
    blackBackground: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    blurBackground: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    disableMobileBlur: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    isOpen: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    isDisabledPanelOverflowxDialog: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    video: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    center: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
    transitionDirection: {
        type: String as PropType<'default' | 'left' | 'right'>,
        default: 'default',
    },
    isDisabledPaddingTablet: {
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const emits = defineEmits(['close'])
const modalPadding = ref('0px')
const isBodyLocked = useScrollLock(document?.body)

watch(
    () => props.isOpen,
    async (newValue) => {
        queueMicrotask(() => {
            modalPadding.value =
                window.document.documentElement.style.paddingRight

            isBodyLocked.value = newValue
        })
    }
)

function closeModal(value: boolean) {
    const event = window.event
    const target = event?.target as HTMLElement

    if (target) {
        const tagName = target.tagName.toLowerCase()
        const isPortalContent =
            target.closest('[data-reka-portal]') ||
            target.closest('.z-\\[50\\]')

        const isSystemTag = tagName === 'html' || tagName === 'body'

        if (isPortalContent || isSystemTag) {
            const isModalOverlay =
                target.classList.contains('fixed') &&
                target.classList.contains('inset-0')

            if (!isModalOverlay) {
                return
            }
        }
    }

    if (value === false) {
        emits('close')
    }
}
</script>
